import { track } from 'lib/analytics/track'
import { InfoButton } from 'components/buttons'
import useCurrentUser from 'shared/hooks/useCurrentUser/useCurrentUser'
import {
  FEATURE_SECTION_COMPONENT_TYPE,
  FeatureBlockProps,
  SINGLE_BLOCK_SECTION_WIDTH,
} from './FeatureBlock.d'
import css from './FeatureBlock.module.scss'
import BannerText from '../BannerText'
import { useDynamicLinkTracking } from '../hooks'

export const FeatureBlock = ({
  backgroundColor,
  backgroundImage,
  buttonText,
  buttonUrl,
  contentfulId,
  imageOverlay,
  imageWidth = SINGLE_BLOCK_SECTION_WIDTH,
  layout,
  slot,
  subText,
  textColor,
  title,
}: FeatureBlockProps) => {
  const [currentUser] = useCurrentUser()
  const registryProps = {
    isRegistryOwner: !!currentUser?.registryId,
    registryOwnerId: currentUser?.id,
    registryId: currentUser?.registryId,
  }

  const baseEventPayload = {
    event: track.componentClicked,
    componentType: FEATURE_SECTION_COMPONENT_TYPE,
    contentId: contentfulId,
    contentName: title,
    slotPosition: slot,
    ...registryProps,
  }

  const { tracker, handleLinkClicked } = useDynamicLinkTracking((link) => ({
    ...baseEventPayload,
    urlClicked: link.href,
  }))

  const handleButtonClicked = () =>
    tracker.trackEvent({
      ...baseEventPayload,
      urlClicked: buttonUrl,
    })

  const className = `
          ${css.FeatureBlock}
          ${css[`BG${backgroundColor}`]}
        `

  const styles = {
    backgroundImage: `url(${backgroundImage}?fm=jpg&fit=fill&w=${imageWidth}&q=50)`,
  }

  return (
    <section className={className} key={contentfulId} style={styles}>
      <BannerText
        dataTestId="featureBlockContent"
        imageOverlay={backgroundImage ? imageOverlay : 'Transparent'}
        layout={layout}
        textColor={textColor}
      >
        <h2>{title}</h2>
        {/* eslint-disable-next-line react/no-danger,jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions */}
        <p
          dangerouslySetInnerHTML={{ __html: subText || '' }}
          onClick={handleLinkClicked}
        />
        {buttonText && buttonUrl && (
          <InfoButton
            pill
            className={css.Button}
            href={buttonUrl}
            onClick={handleButtonClicked}
            role="button"
          >
            {buttonText}
          </InfoButton>
        )}
      </BannerText>
    </section>
  )
}

export default FeatureBlock
